

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETEMPLOYEEKRAKPISTATUSLIST= createAsyncThunk(
  "getEmployeeKraKpiStatusList/getEmployeeKraKpiStatusList",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmployeeKraKpiStatusListSlice = createSlice({
  name: "getEmployeeKraKpiStatusListSlice",
  initialState: {
    getEmployeeKraKpiStatusList: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmployeeKraKpiStatusList: (state) => {
        state.getEmployeeKraKpiStatusList.loading = false
        state.getEmployeeKraKpiStatusList.error = false
        state.getEmployeeKraKpiStatusList.data = []
        state.getEmployeeKraKpiStatusList.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEMPLOYEEKRAKPISTATUSLIST.fulfilled, (state, action) => {
      state.getEmployeeKraKpiStatusList = {
        ...state.getEmployeeKraKpiStatusList,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEKRAKPISTATUSLIST.pending, (state, action) => {
      state.getEmployeeKraKpiStatusList = {
        ...state.getEmployeeKraKpiStatusList,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEKRAKPISTATUSLIST.rejected, (state, action) => {
      state.getEmployeeKraKpiStatusList = {
        ...state.getEmployeeKraKpiStatusList,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmployeeKraKpiStatusListAction = {
    GETEMPLOYEEKRAKPISTATUSLIST,
};

export { getEmployeeKraKpiStatusListAction };
export default getEmployeeKraKpiStatusListSlice.reducer;
export const {setInitialStateOfgetEmployeeKraKpiStatusList} = getEmployeeKraKpiStatusListSlice.actions
